import { FC } from 'react';
import classnames from 'classnames/bind';
import styles from './tooltip.module.scss';
const cx = classnames.bind(styles);

type tooltipType = 'type1' | 'type2' | 'type3' | 'type4' | 'meter' | 'competency';
interface TooltipProps {
  children?: React.ReactNode;
  content: React.ReactNode;
  type?: tooltipType;
  iconSize?: 'small';
}

const Tooltip: FC<TooltipProps> = (props) => {
  const { children, content, type, iconSize } = props;
  return (
    <a className={cx('tooltipArea', type, iconSize)} role="button">
      {children}
      {/* type1 ~ type3 클래스 추가해주세요.(type1은 기본타입) */}
      <div className={cx('tooltip', type)}>{content}</div>
    </a>
  );
};

export default Tooltip;
